/* tslint:disable:max-line-length */
import React from 'react';
import './icons.scss';

export function AlertIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M12,16.6c-0.4,0-0.8-0.3-0.8-0.8V9.3c0-0.4,0.3-0.8,0.8-0.8c0.4,0,0.8,0.3,0.8,0.8v6.6C12.8,16.3,12.4,16.6,12,16.6z"/>
            <path d="M23.2,23.2H0.8c-0.3,0-0.5-0.1-0.7-0.4c-0.1-0.2-0.1-0.5,0-0.8L11.3,1.2c0.1-0.3,0.4-0.4,0.7-0.4s0.5,0.2,0.7,0.4l11.2,20.9c0.1,0.2,0.1,0.5,0,0.8C23.8,23.1,23.5,23.2,23.2,23.2z M2.1,21.7h19.9L12,3.2L2.1,21.7z"/>
            <path d="M12,19.7c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2S12.6,19.7,12,19.7z M12,18.2c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C12.4,18.4,12.2,18.2,12,18.2z"/>
        </svg>
    );
}

export function ArrowLeftIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M7.4,12L18.7,1.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-12,10.9C5.1,11.4,5,11.7,5,12c0,0.3,0.1,0.6,0.3,0.8l12,10.9c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4L7.4,12z"/>
        </svg>
    );
}

export function ArrowRightIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M18.7,11.2L6.7,0.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L16.6,12L5.3,22.3c-0.4,0.4-0.4,1,0,1.4,c0.4,0.4,1,0.4,1.4,0l12-10.9c0.2-0.2,0.3-0.5,0.3-0.8C19,11.7,18.9,11.4,18.7,11.2z"/>
        </svg>
    );
}

export function BasketIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M6,9.8c-0.1,0-0.2,0-0.2,0c-0.4-0.1-0.6-0.6-0.5-1l2.1-6.8c0.1-0.4,0.6-0.6,1-0.5c0.4,0.1,0.6,0.6,0.5,1L6.8,9.3 C6.6,9.6,6.3,9.8,6,9.8z"/>
            <path d="M18,9.8c-0.3,0-0.6-0.2-0.7-0.5l-2.1-6.8c-0.1-0.4,0.1-0.8,0.5-1c0.4-0.1,0.8,0.1,1,0.5l2.1,6.8c0.1,0.4-0.1,0.8-0.5,1 C18.1,9.8,18.1,9.8,18,9.8z"/>
            <path d="M20.2,22.5H3.8c-0.4,0-0.7-0.2-0.8-0.6L0,9.5C0,9.2,0,9,0.2,8.8c0.1-0.2,0.4-0.3,0.6-0.3h22.5c0.2,0,0.5,0.1,0.6,0.3 C24,9,24,9.2,24,9.5l-3,12.4C20.9,22.2,20.6,22.5,20.2,22.5z M4.4,20.9h15.2l2.6-10.8H1.8L4.4,20.9z"/>
        </svg>
    );
}

export function BinaucularsIcon() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 61 53">
            <path d="M60.68,37.71a.15.15,0,0,1,0-.07L55,7.1A.24.24,0,0,0,55,7a.2.2,0,0,0,0-.07A9.66,9.66,0,0,0,36,9.66V15H25V9.5a.88.88,0,0,0,0-.16A9.66,9.66,0,0,0,6.06,7a.22.22,0,0,0,0,.08A.14.14,0,0,0,6,7.1L.33,37.64a.15.15,0,0,1,0,.07A12.83,12.83,0,0,0,0,40.5a12.5,12.5,0,0,0,25,0h0v-10a.51.51,0,0,1,.5-.5h10a.51.51,0,0,1,.5.5v10h0a12.5,12.5,0,0,0,25,0A12.83,12.83,0,0,0,60.68,37.71ZM12.5,50A9.5,9.5,0,1,1,22,40.5,9.51,9.51,0,0,1,12.5,50Zm23-23h-10A3.5,3.5,0,0,0,22,30.5v1.9A12.45,12.45,0,0,0,4.66,30.78L9,7.76A6.66,6.66,0,0,1,22,9.66V16.5A1.5,1.5,0,0,0,23.5,18h14A1.5,1.5,0,0,0,39,16.5V9.66a6.66,6.66,0,0,1,13-1.9l4.29,23A12.45,12.45,0,0,0,39,32.4V30.5A3.5,3.5,0,0,0,35.5,27Zm13,23A9.5,9.5,0,1,1,58,40.5,9.51,9.51,0,0,1,48.5,50Z"/>
        </svg>
    );
}

export function BubbleIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M23,10.7C23,4.8,18.1,0,12,0C5.9,0,1,4.8,1,10.7c0,4.8,3.3,8.9,7.8,10.2l3.1,3.1l3.1-3 C19.6,19.7,23,15.6,23,10.7z"/>
        </svg>
    );
}

export function BullseyeIcon() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 61 61.13">
            <path d="M59.5,52.06H54.12L36.79,34.73A7.43,7.43,0,0,0,38,30.59a7.52,7.52,0,1,0-7.51,7.51,7.45,7.45,0,0,0,4.14-1.25L52,54.18v5.38a1.5,1.5,0,0,0,3,0v-4.5h4.5a1.5,1.5,0,0,0,0-3Zm-29-17a4.54,4.54,0,1,1,4.06-2.57l-2-2a1.51,1.51,0,0,0-2.12,0,1.49,1.49,0,0,0,0,2.12l2,2A4.5,4.5,0,0,1,30.53,35.1Z"/><path d="M44.45,54.34A27.31,27.31,0,1,1,54.57,44a1.5,1.5,0,1,0,2.62,1.46A30.53,30.53,0,1,0,46,56.92a1.5,1.5,0,1,0-1.53-2.58Z"/><path d="M46.4,37.14a1.49,1.49,0,0,0,1.87-1A18.54,18.54,0,0,0,30.5,12.06,18.31,18.31,0,0,0,12,30.56a18.3,18.3,0,0,0,18.5,18.5,18,18,0,0,0,6.12-.86,1.5,1.5,0,0,0-1-2.84,15,15,0,0,1-5.13.7A15.34,15.34,0,0,1,15,30.56a15.34,15.34,0,0,1,15.5-15.5,15.55,15.55,0,0,1,14.91,20.2A1.5,1.5,0,0,0,46.4,37.14Z"/>
        </svg>
    );
}

export function CalendarIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M17.2,21h1.5c0.8,0,1.5-0.7,1.5-1.5V18c0-0.8-0.7-1.5-1.5-1.5h-1.5c-0.8,0-1.5,0.7-1.5,1.5v1.5 C15.8,20.3,16.4,21,17.2,21z M17.2,18h1.5v1.5h-1.5V18z M17.2,15h1.5c0.8,0,1.5-0.7,1.5-1.5V12c0-0.8-0.7-1.5-1.5-1.5h-1.5 c-0.8,0-1.5,0.7-1.5,1.5v1.5C15.8,14.3,16.4,15,17.2,15z M17.2,12h1.5v1.5h-1.5V12z M11.2,15h1.5c0.8,0,1.5-0.7,1.5-1.5V12 c0-0.8-0.7-1.5-1.5-1.5h-1.5c-0.8,0-1.5,0.7-1.5,1.5v1.5C9.8,14.3,10.4,15,11.2,15z M11.2,12h1.5v1.5h-1.5V12z M5.2,21h1.5 c0.8,0,1.5-0.7,1.5-1.5V18c0-0.8-0.7-1.5-1.5-1.5H5.2c-0.8,0-1.5,0.7-1.5,1.5v1.5C3.8,20.3,4.4,21,5.2,21z M5.2,18h1.5v1.5H5.2V18 z M20.2,1.5h-3V0.8c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v0.8H8.2V0.8C8.2,0.3,7.9,0,7.5,0C7.1,0,6.8,0.3,6.8,0.8v0.8h-3 c-1.7,0-3,1.3-3,3V21c0,1.7,1.3,3,3,3h16.5c1.7,0,3-1.3,3-3V4.5C23.2,2.8,21.9,1.5,20.2,1.5z M21.8,21c0,0.8-0.7,1.5-1.5,1.5H3.8 c-0.8,0-1.5-0.7-1.5-1.5V7.5h19.5V21z M21.8,6H2.2V4.5C2.2,3.7,2.9,3,3.8,3h3v0.8c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8V3 h7.5v0.8c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8V3h3c0.8,0,1.5,0.7,1.5,1.5V6z M5.2,15h1.5c0.8,0,1.5-0.7,1.5-1.5V12 c0-0.8-0.7-1.5-1.5-1.5H5.2c-0.8,0-1.5,0.7-1.5,1.5v1.5C3.8,14.3,4.4,15,5.2,15z M5.2,12h1.5v1.5H5.2V12z M11.2,21h1.5 c0.8,0,1.5-0.7,1.5-1.5V18c0-0.8-0.7-1.5-1.5-1.5h-1.5c-0.8,0-1.5,0.7-1.5,1.5v1.5C9.8,20.3,10.4,21,11.2,21z M11.2,18h1.5v1.5 h-1.5V18z"/>
        </svg>
    );
}

export function CaretDownIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M23.6,5.8c-0.5-0.5-1.4-0.5-1.9,0L12,15.5L2.3,5.8c-0.5-0.5-1.4-0.5-1.9,0c-0.5,0.5-0.5,1.4,0,1.9l10.4,10.4 c0.3,0.3,0.8,0.4,1.2,0.4c0.4,0.1,0.9,0,1.2-0.4L23.6,7.8C24.1,7.2,24.1,6.4,23.6,5.8z"/>
        </svg>
    );
}

export function CartIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M4.5,21c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3S4.5,19.3,4.5,21z M7.5,19.5C8.3,19.5,9,20.2,9,21s-0.7,1.5-1.5,1.5 S6,21.8,6,21S6.7,19.5,7.5,19.5z M6,16.5c-0.8,0-1.5-0.7-1.5-1.5l17.2-1.5c0,0,2.2-9.1,2.2-9.8C24,3.3,23.7,3,23.2,3H4.5V1.5h0.8 C5.7,1.5,6,1.2,6,0.8C6,0.3,5.7,0,5.2,0H0.8C0.3,0,0,0.3,0,0.8c0,0.4,0.3,0.8,0.8,0.8H3V15c0,1.7,1.3,3,3,3h1.5h9h6.8 c0,0,0-0.7,0-1.5H6z M4.5,4.5h18l-1.9,7.7L4.5,13.5V4.5z M13.5,21c0,1.7,1.3,3,3,3s3-1.3,3-3s-1.3-3-3-3S13.5,19.3,13.5,21z M16.5,19.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5S15,21.8,15x1,21S15.7,19.5,16.5,19.5z"/>
        </svg>
    );
}

export function CheckListIcon() {
    return (
        <svg viewBox="0 0 61 53" className="cpd-icon" strokeWidth="3" fill="#353a40">
            <line x1="23.5" y1="26.5" x2="59.5" y2="26.5"/>
            <line x1="23.5" y1="7.5" x2="59.5" y2="7.5"/>
            <polyline points="13.8 1.5 7.18 10.5 1.8 7.14"/>
            <circle cx="7.5" cy="26.5" r="6"/>
            <line x1="23.5" y1="45.5" x2="59.5" y2="45.5"/>
            <circle cx="7.5" cy="45.5" r="6"/>
        </svg>
    );
}

export function CheckmarkCircleIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z M12,1.5C6.2,1.5,1.5,6.2,1.5,12S6.2,22.5,12,22.5 S22.5,17.8,22.5,12S17.8,1.5,12,1.5z"/>
            <path d="M10.6,16.6c-0.2,0-0.4-0.1-0.5-0.2l-4.4-4.4c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l3.8,3.8l6.7-7.2 c0.3-0.3,0.8-0.3,1.1,0c0.3,0.3,0.3,0.8,0,1.1l-7.2,7.7C11,16.6,10.8,16.6,10.6,16.6C10.6,16.6,10.6,16.6,10.6,16.6z"/>
        </svg>
    );
}

export function CheckmarkIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M9.5,20.5c-0.4,0-0.7-0.1-1-0.4l-8.1-7.9c-0.6-0.5-0.6-1.4,0-2c0.5-0.6,1.4-0.6,2,0l7,6.9L21.6,4c0.5-0.6,1.4-0.6,2-0.1 c0.6,0.5,0.6,1.4,0.1,2L10.5,20C10.2,20.3,9.9,20.5,9.5,20.5C9.5,20.5,9.5,20.5,9.5,20.5z"/>
        </svg>
    );
}

export function CloseIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M14.8,12l8.6-8.6c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0L12,9.2L3.4,0.6c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8 L9.2,12l-8.6,8.6c-0.8,0.8-0.8,2,0,2.8C1,23.8,1.5,24,2,24s1-0.2,1.4-0.6l8.6-8.6l8.6,8.6C21,23.8,21.5,24,22,24s1-0.2,1.4-0.6 c0.8-0.8,0.8-2,0-2.8L14.8,12z"/>
        </svg>
    );
}

export function CloseCircleIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M14.6,8.3l-2.7,2.7L9.3,8.3C9,8,8.5,8,8.2,8.3c-0.3,0.3-0.4,0.8,0,1.1l2.7,2.7l-2.5,2.5C8,15,8,15.5,8.3,15.8 c0.3,0.3,0.8,0.4,1.1,0l2.7-2.7l2.7,2.7c0.3,0.3,0.8,0.4,1.1,0c0.3-0.3,0.4-0.8,0-1.1L13.3,12L16,9.3c0.3-0.3,0.4-0.8,0-1.1 C15.4,8,14.9,8,14.6,8.3z M3.5,3.5c-4.7,4.7-4.7,12.3,0,17s12.3,4.7,17,0s4.7-12.3,0-17S8.2-1.2,3.5,3.5z M19.4,19.4 c-4.1,4.1-10.7,4.1-14.8,0S0.5,8.7,4.6,4.6s10.7-4.1,14.8,0S23.5,15.3,19.4,19.4z"/>
        </svg>
    );
}

export function DashboardIcon() {
    return (
        <svg viewBox="0 0 20 20" className="cpd-icon">
            <g>
                <polygon points="2 0 0 0 0 20 20 20 20 18 2 18 2 0" />
                <polygon points="14 5 14 7 16.59 7 13 10.59 10 7.59 4 13.59 5.41 15 10 10.41 13 13.41 18 8.41 18 11 20 11 20 5 14 5"/>
            </g>
        </svg>
    );
}

export function DocumentIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M16.5,16.5h-9c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h9c0.4,0,0.7-0.3,0.7-0.7C17.2,16.8,16.9,16.5,16.5,16.5z M15.7,0L15.7,0c-0.1,0-0.5,0-1.5,0h-9c-1.7,0-3,1.3-3,3v18c0,1.7,1.3,3,3,3h13.5c1.7,0,3-1.3,3-3V7.5c0-0.2,0-0.4,0-1.5L15.7,0z M20.2,21c0,0.8-0.7,1.5-1.5,1.5H5.3c-0.8,0-1.5-0.7-1.5-1.5V3c0-0.8,0.7-1.5,1.5-1.5h9c0,1.8,0,3,0,3c0,1.7,1.3,3,3,3 c0,0,1.3,0,3,0V21z M17.2,6c-0.8,0-1.5-0.7-1.5-1.5c0,0,0-1.2,0-3L20.2,6H17.2z M16.5,12h-9c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7h9c0.4,0,0.7-0.3,0.7-0.7C17.2,12.3,16.9,12,16.5,12z"/>
        </svg>
    );
}

export function DownloadIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M11.2,19.7c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3l4.9-6c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-3.3,4V1 c0-0.6-0.4-1-1-1s-1,0.4-1,1v15.3l-3.3-4c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4L11.2,19.7z M21,22H3c-0.6,0-1,0.4-1,1 c0,0.6,0.4,1,1,1h18c0.6,0,1-0.4,1-1C22,22.4,21.6,22,21,22z"/>
        </svg>
    );
}

export function EarnedCheckMark() {
    return (
        <svg viewBox="0 0 70 70" className="cpd-icon">
            <circle cx="35" cy="35" r="35" fill="#2b8441"/>
            <polyline points="59.02 19.48 32.69 49.59 17.45 35.25" fill="none" stroke="#FFFFFF" strokeWidth="2"/>
        </svg>
    );
}

export function EyeOpenIcon() {
    return (
    <svg viewBox="0 0 24 24" className="cpd-icon">
        <path d="M12,3.9C4.2,3.9,0,9.6,0,12s4.2,8.1,12,8.1s12-5.8,12-8.1S19.8,3.9,12,3.9z M12,18.7c-7.2,0-10.6-5.4-10.6-6.7 S4.8,5.3,12,5.3s10.6,5.4,10.6,6.7S19.2,18.7,12,18.7z"/>
        <path d="M12,7c-2.8,0-5,2.2-5,5s2.2,5,5,5s5-2.2,5-5S14.8,7,12,7z M12,15.6c-2,0-3.6-1.6-3.6-3.6c0-2,1.6-3.6,3.6-3.6 c2,0,3.6,1.6,3.6,3.6C15.6,14,14,15.6,12,15.6z"/>
    </svg>
    );
}

export function EyeClosedIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M20.6,6.8l-0.9,1.1c1.9,1.5,2.9,3.6,2.9,4.1c0,1.3-3.4,6.7-10.6,6.7c-1.1,0-2.5-0.2-3.4-0.4l-0.3,1.4 c0.9,0.2,2.5,0.4,3.6,0.4c7.8,0,12-5.8,12-8.1C24,10.8,22.6,8.4,20.6,6.8z"/>
            <path d="M21.6,1.4L18,5c-1.4-0.8-4-1.1-6-1.1C4.2,3.9,0,9.6,0,12c0,1.2,1.6,4.3,4.6,6.4l-3.3,3.3l1,1L22.6,2.4L21.6,1.4z M1.4,12 c0-1.3,3.4-6.7,10.6-6.7c1.6,0,3.7,0.3,4.9,0.8L15,8c-0.9-0.6-1.9-1-3-1c-2.8,0-5,2.2-5,5c0,1.1,0.4,2.1,1,3l-2.3,2.3 C2.7,15.5,1.4,12.6,1.4,12z M8.4,12c0-2,1.6-3.6,3.6-3.6c0.7,0,1.4,0.2,2,0.6l-5,5C8.6,13.4,8.4,12.7,8.4,12z"/>
            <path d="M12,15.6c-0.2,0-0.3,0-0.5,0l-0.2,1.4c0.2,0,0.4,0,0.7,0c2.8,0,5-2.2,5-5c0-0.2,0-0.4,0-0.7l-1.4,0.2c0,0.2,0,0.3,0,0.5 C15.6,14,14,15.6,12,15.6z"/>
        </svg>
    );
}

export function ExclamationIcon() {
    return (
        <svg viewBox="0 0 6 35" className="cpd-icon" fill="#c5021e" >
            <line x1="3" y1="24" x2="3" y2="2"/>
            <line x1="3" y1="32" x2="3" y2="32"/>
            <circle cx="3" cy="32" r="1"/>
        </svg>
    );
}

export function FailureIcon() {
    return (
        <svg viewBox="0 0 70 70" className="cpd-icon">
            <circle cx="35" cy="35" r="35" fill="#c5021e"/>
            <line x1="48.17" y1="19.48" x2="21.83" y2="49.59" stroke="#FFFFFF" strokeWidth="2"/>
            <line x1="21.83" y1="19.48" x2="48.17" y2="49.59" stroke="#FFFFFF" strokeWidth="2"/>
        </svg>
    );
}

export function FinalResultIcon() {
    return (
        <svg viewBox="0 0 45 24" className="cpd-icon">
            <polyline points="2.5 21.5 16.5 10.5 24.5 19.5 42.5 2.5"/>
            <polyline points="42.5 10.5 42.5 2.5 34.5 2.5" />
        </svg>
    );
}

export function FolderIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M21,3H10.5c0-1.7-1.3-3-3-3H3C1.3,0,0,1.3,0,3v18c0,1.7,1.3,3,3,3h18c1.7,0,3-1.3,3-3V6C24,4.3,22.7,3,21,3z M22.5,21 c0,0.8-0.7,1.5-1.5,1.5H3c-0.8,0-1.5-0.7-1.5-1.5V9h21V21z M22.5,7.5h-21V3c0-0.8,0.7-1.5,1.5-1.5h4.5C8.3,1.5,9,2.2,9,3v1.5h12 c0.8,0,1.5,0.7,1.5,1.5V7.5z"/>
        </svg>
    );
}

export function GearsIcon() {
    return (
        <svg viewBox="0 0 60.91 59.98" className="cpd-icon" fill="#353a40">
            <path d="M58.72,46.68,57,45.92a1.93,1.93,0,0,1-1-1.26l-.13-.43a6.65,6.65,0,0,0-.43-1.11,1.83,1.83,0,0,1,.07-1.65l.69-1.09A1.2,1.2,0,0,0,56,38.92L54.3,37.33a1.2,1.2,0,0,0-1.47-.09l-1.29.94a2.2,2.2,0,0,1-1.24.36,1.59,1.59,0,0,1-.45-.06l-1.3-.24a1.94,1.94,0,0,1-1.39-.93l-.63-1.21a1.21,1.21,0,0,0-1.05-.61,1,1,0,0,0-.31,0L43,36.22a1.2,1.2,0,0,0-.81,1.23L42.32,39a2.18,2.18,0,0,1-.59,1.61l-.67.74a2.06,2.06,0,0,1-1.48.73h0l-1.47-.06h0a1.2,1.2,0,0,0-1.12.89l-.53,2.26A1.21,1.21,0,0,0,37,46.53l1.31.58a1.91,1.91,0,0,1,1,1.33,5.69,5.69,0,0,0,.2.76c.16.54.21.65.21.65a1.93,1.93,0,0,1-.1,1.67l-.76,1.2a1.21,1.21,0,0,0,.18,1.46l1.69,1.59a1.2,1.2,0,0,0,1.47.08l1.1-.81a2,2,0,0,1,1.13-.33,1.63,1.63,0,0,1,.54.08l1.33.33a2.13,2.13,0,0,1,1.39,1l.91,1.75a1.21,1.21,0,0,0,1.05.62,1,1,0,0,0,.3,0l2.22-.68A1.21,1.21,0,0,0,53,56.53l-.22-1.95A2.1,2.1,0,0,1,53.43,53l1.06-1.18A2,2,0,0,1,56,51.08H56l1.68.07h0a1.21,1.21,0,0,0,1.13-.89L59.38,48A1.2,1.2,0,0,0,58.72,46.68Z"/>
            <ellipse cx="21.38" cy="21.5" rx="5.95" ry="5.97"/>
            <circle cx="47.87" cy="47.04" r="3.56"/>
            <path d="M36.11,24.89l5.31-.82,0-5.21-5.32-.7a14.94,14.94,0,0,0-2-4.67l3.24-4.32-3.7-3.68-4.32,3.3A14.9,14.9,0,0,0,24.78,6.9L24,1.5H18.79L18.1,6.9a14.91,14.91,0,0,0-4.66,1.94L9.14,5.56,5.47,9.27,8.77,13.5a15,15,0,0,0-2,4.68L1.5,19l0,5.21,5.26.66a14.92,14.92,0,0,0,1.93,4.68L5.55,33.88l3.7,3.68,4.28-3.24a14.94,14.94,0,0,0,4.59,1.89l.81,5.32,5.2,0,.7-5.32a15,15,0,0,0,4.62-1.92l4.34,3.2,3.67-3.71L34.21,29.5A14.94,14.94,0,0,0,36.11,24.89Z"/>
        </svg>
    );
}

export function GoalLevelBarsIcon() {
    return (
        <svg viewBox="0 0 59 61" className="cpd-icon" fill="#353a40">
            <rect x="1.5" y="31.5" width="12" height="28"/>
            <rect x="22.5" y="21.5" width="14" height="38"/>
            <rect x="45.5" y="1.5" width="12" height="58"/>
        </svg>
    );
}
export function Happy() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" className="cpd-icon"  viewBox="0 0 61 61" fill="none">
            <circle fill="none" cx="30.5" cy="30.5" r="29"/>
            <path fill="none" d="M45.5,37.5c-2.78,5.88-8.42,10-15,10s-12.21-4.14-15-10"/>
            <circle fill="none" cx="20.5" cy="24.5" r="2"/>
            <path fill="none" d="M42.5,24.5a2,2,0,1,1-2-2A2,2,0,0,1,42.5,24.5Z"/>
        </svg>
    );
}

export function DownArrow() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" className="cpd-icon" stroke="#828282" viewBox="0 0 61 61" fill="none">
            <path fill="none" d="M3.67,2.23c-1.49,0-2.1,1.07-1.35,2.38L29.43,52c.74,1.3,1.95,1.3,2.67,0L58.68,4.36c.72-1.31.1-2.37-1.4-2.36Z"/>
        </svg>
    );
}

export function UpArrow() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" className="cpd-icon" stroke="#828282" viewBox="0 0 61 61" fill="none">
            <path fill="none" d="M3.67,52.79c-1.49,0-2.1-1.08-1.35-2.38L29.43,3c.74-1.31,1.95-1.31,2.67,0L58.68,50.66c.72,1.3.1,2.36-1.4,2.36Z"/>
        </svg>
    );
}

export function Sad() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 61 61" stroke="#828282" fill="none">
            <circle fill="none" cx="30.5" cy="30.5" r="29"/>
            <path fill="none" d="M15.5,45.5c2.78-5.88,8.42-10,15-10s12.21,4.14,15,10"/>
            <circle fill="none" cx="20.5" cy="24.5" r="2"/>
            <path fill="none" d="M42.5,24.5a2,2,0,1,1-2-2A2,2,0,0,1,42.5,24.5Z"/>
        </svg>
    );
}

export function Target() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 61 61" stroke="#828282" fill="none">
            <line x1="30.5" y1="53.7" x2="30.5" y2="59.5"/>
            <line x1="30.5" y1="1.5" x2="30.5" y2="7.3"/>
            <line x1="59.5" y1="30.5" x2="53.7" y2="30.5"/>
            <line x1="7.3" y1="30.5" x2="1.5" y2="30.5"/>
            <circle cx="30.5" cy="30.5" r="23"/>
            <circle cx="30.5" cy="30.5" r="12"/>
        </svg>
    );
}
export function HourGlassIcon() {
    return (
        <svg className="cpd-icon" viewBox="0 0 18.49 27.69" width="21" height="27">
           <line y1="0.75" x2="17.49" y2="0.75"/>
           <line x1="15.19" y1="0.75" x2="15.19" y2="7.65"/>
           <line x1="2.3" y1="0.75" x2="2.3" y2="7.65"/>
           <path d="M2.3,7.65c0,4.79,5.76,6.45,6.45,6.45h0c.69,0,6.45-1.66,6.45-6.45"/>
           <line x1="17.49" y1="27.44" y2="27.44"/><line x1="2.3" y1="27.44" x2="2.3" y2="20.54"/>
           <line x1="15.19" y1="27.44" x2="15.19" y2="20.54"/>
           <path d="M15.19,20.54c0-4.78-5.76-6.44-6.45-6.44h0c-.69,0-6.44,1.66-6.44,6.44"/>
        </svg>
    );
}

export function ImageIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M22.6,22.1H5.2c-0.8,0-1.4-0.6-1.4-1.4V7.1c0-0.8,0.6-1.4,1.4-1.4h17.4c0.8,0,1.4,0.6,1.4,1.4v13.6 C24,21.5,23.4,22.1,22.6,22.1z M4.5,20.7h0.7c0,0,0,0,0,0h17.4l0-13.6l-17.4,0l0,13.6H4.5z"/>
            <path d="M4.5,20.7c-0.2,0-0.3-0.1-0.5-0.2c-0.3-0.3-0.3-0.7-0.1-1l4.9-5.7c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0,0.5,0.2l2.5,2.2 l4.8-5.1c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2l5.6,5.8c0.3,0.3,0.3,0.7,0,1c-0.3,0.3-0.7,0.3-1,0l-5.1-5.3l-4.8,5.1 c-0.3,0.3-0.7,0.3-1,0l-2.5-2.2L5,20.4C4.9,20.6,4.7,20.7,4.5,20.7z"/>
            <path d="M9,12.3c-1,0-1.8-0.8-1.8-1.8S8,8.7,9,8.7c1,0,1.8,0.8,1.8,1.8S10,12.3,9,12.3z M9,10.1c-0.2,0-0.4,0.2-0.4,0.4 c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4C9.4,10.3,9.2,10.1,9,10.1z"/>
            <path d="M19.9,4.9c-0.4,0-0.7-0.3-0.7-0.7V3.3h-1c-0.4,0-0.7-0.3-0.7-0.7s0.3-0.7,0.7-0.7h1.7c0.4,0,0.7,0.3,0.7,0.7v1.6 C20.6,4.6,20.3,4.9,19.9,4.9z"/>
            <path d="M0.7,5.2C0.3,5.2,0,4.9,0,4.5v-2c0-0.4,0.3-0.7,0.7-0.7h1.8c0.4,0,0.7,0.3,0.7,0.7S2.9,3.3,2.5,3.3H1.4v1.2 C1.4,4.9,1.1,5.2,0.7,5.2z"/>
            <path d="M11.4,3.3h-2C9,3.3,8.7,3,8.7,2.6S9,1.9,9.3,1.9h2c0.4,0,0.7,0.3,0.7,0.7S11.7,3.3,11.4,3.3z"/>
            <path d="M15.7,3.3h-1.9c-0.4,0-0.8-0.3-0.8-0.7s0.3-0.7,0.8-0.7h1.9c0.4,0,0.8,0.3,0.8,0.7S16.1,3.3,15.7,3.3z"/>
            <path d="M6.9,3.3h-2C4.5,3.3,4.2,3,4.2,2.6s0.3-0.7,0.7-0.7h2c0.4,0,0.7,0.3,0.7,0.7S7.3,3.3,6.9,3.3z"/>
            <path d="M2.3,18.3H0.7c-0.4,0-0.7-0.3-0.7-0.7v-2c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v1.2h0.9c0.4,0,0.7,0.3,0.7,0.7 C3,17.9,2.7,18.3,2.3,18.3z"/>
            <path d="M0.7,9.7C0.3,9.7,0,9.4,0,9V7c0-0.4,0.3-0.7,0.7-0.7S1.4,6.6,1.4,7v2C1.4,9.4,1.1,9.7,0.7,9.7z"/>
            <path d="M0.7,14.1c-0.4,0-0.7-0.3-0.7-0.7v-2c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v2C1.4,13.8,1.1,14.1,0.7,14.1z"/>
        </svg>
    );
}

export function InfoIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M12,24c-3.2,0-6.2-1.2-8.5-3.5c-4.7-4.7-4.7-12.3,0-17C5.8,1.2,8.8,0,12,0s6.2,1.2,8.5,3.5C22.8,5.8,24,8.8,24,12 c0,3.2-1.2,6.2-3.5,8.5C18.2,22.8,15.2,24,12,24z M12,1.5c-2.8,0-5.4,1.1-7.4,3.1c-4.1,4.1-4.1,10.7,0,14.8c2,2,4.6,3.1,7.4,3.1 s5.4-1.1,7.4-3.1c2-2,3.1-4.6,3.1-7.4s-1.1-5.4-3.1-7.4c0,0,0,0,0,0C17.4,2.6,14.8,1.5,12,1.5z"/>
            <path d="M13.5,17.4h-0.8v-7c0-0.4-0.3-0.8-0.8-0.8h-1.5c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8h0.8v6.2h-0.8 c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8h3.1c0.4,0,0.8-0.3,0.8-0.8C14.3,17.8,14,17.4,13.5,17.4z"/>
            <circle cx="12" cy="6.6" r="1.2"/>
        </svg>
    );
}

export function LinkIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M22.3,20.6c0,0.9-0.8,1.7-1.7,1.7l-17.2,0c-0.9,0-1.7-0.8-1.7-1.7l0-17.2c0-0.9,0.8-1.7,1.7-1.7h9.4V0H3.4 C1.6,0,0,1.9,0,3.8v16.9C0,22.5,1.5,24,3.4,24h16.9c1.9,0,3.8-1.6,3.8-3.4v-9.4h-1.7V20.6z M23.1,0h-6c-0.5,0-0.9,0.4-0.9,0.9 c0,0.5,0.4,0.9,0.9,0.9l3.8,0L8,14c-0.3,0.3-0.3,0.9,0,1.2c0.3,0.3,0.9,0.3,1.2,0l13-12.4l0,4.1c0,0.5,0.4,0.9,0.9,0.9 c0.5,0,0.9-0.4,0.9-0.9v-6C24,0.4,23.6,0,23.1,0z"/>
        </svg>
    );
}

export function ListIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M3.1,8.5H0.8C0.3,8.5,0,8.2,0,7.7V5.4C0,5,0.3,4.6,0.8,4.6h2.3c0.4,0,0.8,0.3,0.8,0.8v2.3C3.9,8.2,3.5,8.5,3.1,8.5z M1.5,7h0.8V6.2H1.5V7z"/>
            <path d="M23.2,7.4H8.1C7.7,7.4,7.4,7,7.4,6.6c0-0.4,0.3-0.8,0.8-0.8h15.1c0.4,0,0.8,0.3,0.8,0.8C24,7,23.7,7.4,23.2,7.4z"/>

            <path d="M3.1,13.9H0.8c-0.4,0-0.8-0.3-0.8-0.8v-2.3c0-0.4,0.3-0.8,0.8-0.8h2.3c0.4,0,0.8,0.3,0.8,0.8v2.3 C3.9,13.6,3.5,13.9,3.1,13.9z M1.5,12.4h0.8v-0.8H1.5V12.4z"/>
            <path d="M23.2,12.8H8.1c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h15.1c0.4,0,0.8,0.3,0.8,0.8S23.7,12.8,23.2,12.8z"/>

            <path d="M3.1,19.4H0.8C0.3,19.4,0,19,0,18.6v-2.3c0-0.4,0.3-0.8,0.8-0.8h2.3c0.4,0,0.8,0.3,0.8,0.8v2.3C3.9,19,3.5,19.4,3.1,19.4 z M1.5,17.8h0.8V17H1.5V17.8z"/>
            <path d="M23.2,18.2H8.1c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8h15.1c0.4,0,0.8,0.3,0.8,0.8S23.7,18.2,23.2,18.2z"/>
        </svg>
    );
}

export function LogoutIcon() {
    return (
        <svg viewBox="0 0 20 20" className="cpd-icon">
            <g>
                <path d="M13.23,13.44v5.18A1.38,1.38,0,0,1,11.85,20H1.38A1.38,1.38,0,0,1,0,18.62V1.38A1.38,1.38,0,0,1,1.38,0H11.85a1.38,1.38,0,0,1,1.38,1.38V6.56H11.08V2.15H2.15v15.7h8.93V13.44Z"/>
                <polygon points="5.89 11 16.18 11 14.34 12.83 15.76 14.24 20 10 15.76 5.76 14.34 7.17 16.18 9 5.89 9 5.89 11"/>
            </g>
        </svg>
    );
}

export function MinusIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M22.5,13.5h-21C0.7,13.5,0,12.8,0,12s0.7-1.5,1.5-1.5h21c0.8,0,1.5,0.7,1.5,1.5S23.3,13.5,22.5,13.5z"/>
        </svg>
    );
}

export function NotificationIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M20,14.4V8c0-4.4-3.6-8-8-8C7.6,0,4,3.6,4,8v6.4l-3.2,6.4h7.3c0.4,1.8,2,3.2,3.9,3.2s3.5-1.4,3.9-3.2h7.3L20,14.4z M12,22.4c-1,0-1.9-0.7-2.3-1.6h4.5C13.9,21.7,13,22.4,12,22.4z M3.2,19.2l2.4-4.8V8c0-3.5,2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4v6.4 l2.4,4.8H3.2z"/>
        </svg>
    );
}

export function PartnerIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M22.9,16.4c-0.6-0.8-1.5-1.4-2.6-1.8c-1.3-0.5-2.9-0.8-4.7-0.8c-1.9,0-3.5,0.3-4.7,0.8c-1.1,0.4-1.9,1.1-2.6,1.8 c-1.1,1.3-1.1,2.7-1.1,2.8C7.2,20.2,8,21,9,21h13.2c1,0,1.8-0.8,1.8-1.8C24,19.1,24,17.8,22.9,16.4z M22.2,19.8H9 c-0.3,0-0.6-0.3-0.6-0.6c0,0,0-1.1,0.9-2.1c1.2-1.4,3.4-2.1,6.3-2.1c3,0,5.1,0.7,6.3,2.1c0.8,1,0.9,2,0.9,2.1 C22.8,19.5,22.5,19.8,22.2,19.8z"/>
            <path d="M15.6,12.6c2.6,0,4.8-2.2,4.8-4.8S18.2,3,15.6,3s-4.8,2.2-4.8,4.8S13,12.6,15.6,12.6z M15.6,4.2c2,0,3.6,1.6,3.6,3.6 s-1.6,3.6-3.6,3.6S12,9.8,12,7.8S13.6,4.2,15.6,4.2z"/>
            <path d="M6.6,15c-0.2,0-0.4,0-0.6,0c-1.3,0-2.4,0.2-3.4,0.6C1.9,16,1.2,16.4,0.8,17C0,18.1,0,19.2,0,19.2c0,1,0.8,1.8,1.8,1.8h3.6 l0,0C5.7,21,6,20.7,6,20.4c0-0.3-0.3-0.6-0.6-0.6H1.8c-0.3,0-0.6-0.3-0.6-0.6c0-0.1,0.1-3,4.8-3c0.2,0,0.4,0,0.6,0 c0.3,0,0.6-0.2,0.6-0.6C7.2,15.3,7,15,6.6,15z"/>
            <path d="M6,13.8c2,0,3.6-1.6,3.6-3.6S8,6.6,6,6.6s-3.6,1.6-3.6,3.6S4,13.8,6,13.8z M6,7.8c1.3,0,2.4,1.1,2.4,2.4 c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4C3.6,8.9,4.7,7.8,6,7.8z"/>
        </svg>
    );
}

export function PencilIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M23.4,4.6l-4-4c-0.8-0.8-1.8-0.8-2.6,0L2.1,15.3l-2,7.3c-0.2,1,0.3,1.5,1.3,1.3l7.3-2L23.4,7.2 C24.2,6.4,24.2,5.4,23.4,4.6z M2,22l1.5-5.5l4,4L2,22z M8.8,19.1c-0.4-0.4-2.6-2.6-4-4l8.6-8.6l4,4L8.8,19.1z M21.4,6.6l-2.6,2.6 l-4-4l2.6-2.6c0.7-0.7,0.7-0.6,1.3,0l2.6,2.6C22.1,5.9,22.1,5.9,21.4,6.6z"/>
        </svg>
    );
}

export function PinIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M12,0C7,0,3,4,3,9c0,3.8,7.5,15,9,15c1.5,0,9-11.3,9-15C21,4,17,0,12,0z M12,21.8c-1.2,0-7.5-9.6-7.5-12.8 c0-4.1,3.4-7.5,7.5-7.5s7.5,3.4,7.5,7.5C19.5,12.1,13.2,21.8,12,21.8z M12,5.2C9.9,5.2,8.2,6.9,8.2,9s1.7,3.8,3.8,3.8 s3.8-1.7,3.8-3.8S14.1,5.2,12,5.2z M12,11.2c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2s2.2,1,2.2,2.2S13.2,11.2,12,11.2z"/>
        </svg>
    );
}

export function PinDropIcon() {
    return (
        <svg viewBox="0 0 45 61" className="cpd-icon" fill="#FFFFF">
            <path d="M1.5,22.71c0,18.68,21,36.79,21,36.79s21-18.11,21-36.79a21,21,0,1,0-42,0Z" stroke="#353a40"/>
            <circle cx="22.5" cy="22.5" r="10" stroke="#353a40"/>
        </svg>
    );
}

export function PlusCircleIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M16.5,11.2h-3.8V7.5c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v3.8H7.5c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8 h3.8v3.8c0,0.4,0.3,0.8,0.8,0.8c0.4,0,0.8-0.3,0.8-0.8v-3.8h3.8c0.4,0,0.8-0.3,0.8-0.8C17.2,11.6,16.9,11.2,16.5,11.2z M12,0 C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12s12-5.4,12-12C24,5.4,18.6,0,12,0z M12,22.5C6.2,22.5,1.5,17.8,1.5,12 C1.5,6.2,6.2,1.5,12,1.5S22.5,6.2,22.5,12C22.5,17.8,17.8,22.5,12,22.5z"/>
        </svg>
    );
}

export function PlusIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M13.5,10.5l0-9C13.5,0.7,12.8,0,12,0c-0.8,0-1.5,0.7-1.5,1.5v9h-9C0.7,10.5,0,11.2,0,12c0,0.8,0.7,1.5,1.5,1.5l9,0l0,9 c0,0.8,0.7,1.5,1.5,1.5c0.4,0,0.8-0.2,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1.1v-9h9c0.4,0,0.8-0.2,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1.1 c0-0.8-0.7-1.5-1.5-1.5L13.5,10.5z"/>
        </svg>
    );
}

export function QuestionMarkIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M12,17.8c-0.7,0-1.3-0.5-1.4-1.3c0-0.2-0.3-3.8,3.3-6.8C15,8.8,15.4,8,15.4,6.6c0-2.1-1.5-3.8-3.4-3.8 c-2,0-3.4,1.6-3.4,3.7c0,0.8-0.6,1.4-1.4,1.4S5.8,7.2,5.8,6.4C5.8,2.8,8.5,0,12,0c3.4,0,6.2,3,6.2,6.6c0,2.2-0.8,3.8-2.5,5.3 c-2.5,2.1-2.3,4.5-2.3,4.5c0.1,0.8-0.5,1.4-1.3,1.5C12.1,17.8,12,17.8,12,17.8z"/>
            <path d="M12,24c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1s2.1,0.9,2.1,2.1C14.1,23.1,13.1,24,12,24z M12,21.3 c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7C12.7,21.6,12.4,21.3,12,21.3z"/>
        </svg>
    );
}

export function QuestionMarkCircledIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M12,24C5.4,24,0,18.6,0,12S5.4,0,12,0s12,5.4,12,12S18.6,24,12,24z M12,1.5C6.2,1.5,1.5,6.2,1.5,12S6.2,22.5,12,22.5 S22.5,17.8,22.5,12S17.8,1.5,12,1.5z"/>
            <path d="M12,15.5c-0.4,0-0.7-0.3-0.8-0.7c0-0.1-0.2-2.1,1.9-3.9c0.6-0.5,0.8-1,0.8-1.8C13.9,7.9,13.1,7,12,7 c-1.1,0-1.9,0.9-1.9,2.1c0,0.4-0.3,0.8-0.8,0.8S8.5,9.5,8.5,9c0-2,1.5-3.6,3.5-3.6c1.9,0,3.5,1.7,3.5,3.7c0,1.2-0.4,2.2-1.4,3 c-1.4,1.2-1.3,2.5-1.3,2.5C12.8,15.1,12.5,15.4,12,15.5C12,15.5,12,15.5,12,15.5z"/>
            <path d="M12,19c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2c0.6,0,1.2,0.5,1.2,1.2S12.6,19,12,19z M12,17.4c-0.2,0-0.4,0.2-0.4,0.4 s0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4S12.2,17.4,12,17.4z"/>
        </svg>
    );
}

export function RefreshIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M17.8,1.5h5.4c0.4,0,0.8-0.3,0.8-0.8C24,0.3,23.7,0,23.2,0h-7.5C15.7,0,15,0,15,0.8v7.5C15,8.7,15.3,9,15.8,9 s0.8-0.3,0.8-0.8V2.5c3.5,1.7,6,5.3,6,9.5c0,5.8-4.7,10.5-10.5,10.5S1.5,17.8,1.5,12c0-5.3,3.9-9.7,9-10.4V0.1C4.6,0.8,0,5.9,0,12 c0,6.6,5.4,12,12,12s12-5.4,12-12C24,7.5,21.5,3.5,17.8,1.5z"/>
        </svg>
    );
}

export function SadSearchIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M23.8,22.7l-6.2-6.1c1.6-1.8,2.6-4.1,2.6-6.7c0-5.5-4.5-9.9-10.1-9.9C4.5,0,0,4.4,0,9.9s4.5,9.9,10.1,9.9 c2.4,0,4.6-0.8,6.4-2.2l6.2,6.1c0.3,0.3,0.8,0.3,1.1,0C24.1,23.5,24.1,23,23.8,22.7z M10.1,18.3c-4.7,0-8.5-3.8-8.5-8.4 s3.8-8.4,8.5-8.4s8.5,3.8,8.5,8.4C18.6,14.6,14.8,18.3,10.1,18.3z"/>
            <circle cx="7.6" cy="7.4" r="0.8"/>
            <circle cx="12.4" cy="7.4" r="0.8"/>
            <path d="M10,10.6c-2.7,0-4.2,1.7-4.3,1.7c-0.1,0.2-0.1,0.4,0,0.6c0.2,0.2,0.4,0.1,0.6,0c0,0,1.4-1.5,3.7-1.5s3.7,1.5,3.7,1.5 C13.8,13,13.9,13,14,13s0.2,0,0.3-0.1c0.2-0.2,0.2-0.4,0-0.6C14.2,12.3,12.7,10.6,10,10.6z"/>
        </svg>
    );
}

export function SearchIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M23.8,22.7l-6.2-6.1c1.6-1.8,2.6-4.1,2.6-6.7c0-5.5-4.5-9.9-10.1-9.9C4.5,0,0,4.4,0,9.9s4.5,9.9,10.1,9.9 c2.4,0,4.6-0.8,6.4-2.2l6.2,6.1c0.3,0.3,0.8,0.3,1.1,0C24.1,23.5,24.1,23,23.8,22.7z M10.1,18.3c-4.7,0-8.5-3.8-8.5-8.4 c0-4.6,3.8-8.4,8.5-8.4c4.7,0,8.5,3.8,8.5,8.4C18.6,14.6,14.8,18.3,10.1,18.3z"/>
        </svg>
    );
}

export function SettingsIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M23.2,14.8l-1.9-1.1c0.1-0.6,0.2-1.1,0.2-1.7c0-0.6-0.1-1.2-0.2-1.7l1.9-1.1c0.8-0.4,1-1.4,0.6-2.2l-1.6-2.8 c-0.4-0.8-1.4-1-2.2-0.6l-1.9,1.1c-0.9-0.8-1.9-1.4-3-1.8V1.6c0-0.9-0.7-1.6-1.6-1.6h-3.2C9.5,0,8.8,0.7,8.8,1.6V3 c-1.1,0.4-2.1,1-3,1.8L4,3.6C3.2,3.2,2.2,3.4,1.8,4.2L0.2,7C-0.2,7.8,0,8.7,0.8,9.2l1.9,1.1c-0.1,0.6-0.2,1.1-0.2,1.7 c0,0.6,0.1,1.2,0.2,1.7l-1.9,1.1c-0.8,0.4-1,1.4-0.6,2.2l1.6,2.8c0.4,0.8,1.4,1,2.2,0.6l1.9-1.1c0.9,0.8,1.9,1.4,3,1.8v1.4 c0,0.9,0.7,1.6,1.6,1.6h3.2c0.9,0,1.6-0.7,1.6-1.6V21c1.1-0.4,2.1-1,3-1.8l1.9,1.1c0.8,0.4,1.7,0.2,2.2-0.6l1.6-2.8 C24.2,16.2,24,15.3,23.2,14.8z M22,16.9l-0.8,1.4c-0.2,0.4-0.7,0.5-1.1,0.3l-2.2-1.3c-1.1,1.3-2.6,2.2-4.3,2.5v1.8 c0,0.4-0.4,0.8-0.8,0.8h-1.6c-0.4,0-0.8-0.4-0.8-0.8v-1.8c-1.7-0.4-3.2-1.3-4.3-2.5l-2.2,1.3c-0.4,0.2-0.9,0.1-1.1-0.3L2,16.9 c-0.2-0.4-0.1-0.9,0.3-1.1l2.2-1.3c-0.3-0.8-0.4-1.6-0.4-2.5s0.2-1.7,0.4-2.5L2.3,8.2C1.9,8,1.8,7.5,2,7.1l0.8-1.4 C3,5.3,3.5,5.2,3.9,5.4l2.2,1.3c1.1-1.3,2.6-2.2,4.3-2.5V2.4c0-0.4,0.4-0.8,0.8-0.8h1.6c0.4,0,0.8,0.4,0.8,0.8v1.8 c1.7,0.4,3.2,1.3,4.3,2.5l2.2-1.3c0.4-0.2,0.9-0.1,1.1,0.3L22,7.1c0.2,0.4,0.1,0.9-0.3,1.1l-2.2,1.3c0.3,0.8,0.4,1.6,0.4,2.5 s-0.2,1.7-0.4,2.5l2.2,1.3C22.1,16,22.2,16.5,22,16.9z M12,8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S14.2,8,12,8z M12,14.4 c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4C14.4,13.3,13.3,14.4,12,14.4z"/>
        </svg>
    );
}

export function ShoppingIcon() {
    return (
        <svg viewBox="0 0 20 20" className="cpd-icon">
            <path d="M19.8,5c-0.2-0.3-0.5-0.4-0.8-0.4H6.2L5.3,1.4C5,0.6,4.3,0,3.4,0H0v2h3.3l3.6,12.5c0.1,0.5,0.5,0.9,1,0.9h8.4 c0.5,0,0.9-0.3,1-0.7L20,5.9C20.1,5.6,20,5.2,19.8,5z M15.6,13.4H8.7l-2-6.8h10.9L15.6,13.4z"/>
            <ellipse cx="9.1" cy="18.1" rx="1.9" ry="1.9"/>
            <ellipse cx="14.9" cy="18.1" rx="1.9" ry="1.9"/>
        </svg>
    );
}
export function ShoppingBagIcon() {
    return (
        <svg viewBox="0 0 20 17.38" className="cpd-icon" >
            <path d="M19.89,6.09a.47.47,0,0,0-.38-.19h-4L13.75.35A.5.5,0,0,0,13.13,0a.49.49,0,0,0-.32.62L14.45,5.9H5.54L7.19.64A.49.49,0,0,0,6.87,0a.5.5,0,0,0-.62.33L4.51,5.9h-4a.47.47,0,0,0-.38.19.49.49,0,0,0-.1.42L2.55,17a.49.49,0,0,0,.48.38H17a.49.49,0,0,0,.48-.38L20,6.51A.49.49,0,0,0,19.89,6.09Zm-3.31,10.3H3.42l-2.3-9.5H18.88Z"/>
        </svg>
    );
}

export function SpinIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M15,2.6l2-1.2c0.4-0.2,0.5-0.7,0.3-1.1c-0.2-0.4-0.7-0.5-1.1-0.3l-3.9,2.2c-0.2,0.1-0.3,0.3-0.4,0.5c0,0.2,0,0.4,0.1,0.6 L14.4,7c0.1,0.2,0.4,0.4,0.6,0.4c0.1,0,0.3,0,0.4-0.1C15.9,7,16,6.5,15.7,6.2L14.4,4c3.7,0.9,6.2,4,6.2,7.9c0,3.8-2.4,7.1-5.8,8.2 c-0.4,0.1-0.6,0.6-0.5,1c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,0.2,0,0.2,0c4.1-1.2,6.9-5.2,6.9-9.7C22.1,7.5,19.2,3.7,15,2.6z"/>
            <path d="M9.6,17c-0.2-0.4-0.7-0.5-1.1-0.2C8.1,17,8,17.5,8.3,17.8L9.6,20C6,19.1,3.5,16,3.5,12c0-3.8,2.4-7.1,5.8-8.2 c0.4-0.1,0.6-0.6,0.5-1c-0.1-0.4-0.6-0.6-1-0.5C4.8,3.6,1.9,7.6,1.9,12c0,4.5,2.9,8.2,7,9.4l-2,1.2c-0.4,0.2-0.5,0.7-0.3,1.1 C6.8,23.9,7.1,24,7.4,24c0.1,0,0.3,0,0.4-0.1l3.9-2.2c0.2-0.1,0.3-0.3,0.4-0.5c0-0.2,0-0.4-0.1-0.6L9.6,17z"/>
        </svg>
    );
}

export function TrashIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M15.8,21c0.4,0,0.8-0.3,0.8-0.8v-9c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v9C15,20.7,15.3,21,15.8,21z M12,21c0.4,0,0.8-0.3,0.8-0.8v-9c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v9C11.2,20.7,11.6,21,12,21z M20.2,3h-4.5V1.5c0-0.8-0.7-1.5-1.5-1.5H9.8C8.9,0,8.2,0.7,8.2,1.5V3H3.8C2.9,3,2.2,3.7,2.2,4.5V6c0,0.8,0.7,1.5,1.5,1.5V21c0,1.7,1.3,3,3,3h10.5 c1.7,0,3-1.3,3-3V7.5c0.8,0,1.5-0.7,1.5-1.5V4.5C21.8,3.7,21.1,3,20.2,3z M9.8,2.2c0-0.4,0.3-0.8,0.8-0.8h3c0.4,0,0.8,0.3,0.8,0.8 V3c-0.7,0-4.5,0-4.5,0V2.2z M18.8,21c0,0.8-0.7,1.5-1.5,1.5H6.8c-0.8,0-1.5-0.7-1.5-1.5V7.5c1,0,12.7,0,13.5,0V21z M19.5,6h-15 C4.1,6,3.8,5.7,3.8,5.2c0-0.4,0.3-0.8,0.8-0.8h15c0.4,0,0.8,0.3,0.8,0.8C20.2,5.7,19.9,6,19.5,6z M8.2,21C8.7,21,9,20.7,9,20.2v-9 c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v9C7.5,20.7,7.8,21,8.2,21z"/>
        </svg>
    );
}

export function Trophy() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 61 61">
            <path d="M61,5.5A1.5,1.5,0,0,0,59.5,4H50V1.5A1.5,1.5,0,0,0,48.5,0h-36A1.5,1.5,0,0,0,11,1.5V4H1.5A1.5,1.5,0,0,0,0,5.5c0,5.79,4.7,12.44,11,13.38v3.89A1.24,1.24,0,0,0,11,23,19.48,19.48,0,0,0,26,41.45V46c0,3.16-2.9,7-6.5,7h0l-.19,0h-.11l-.1,0a1.54,1.54,0,0,0-.43.2l0,0a1.3,1.3,0,0,0-.18.15l-.07.08-.12.15a.59.59,0,0,0,0,.08,1.62,1.62,0,0,0-.1.18h0l-2,5h0v0a.38.38,0,0,0,0,.1,1.21,1.21,0,0,0,0,.18c0,.05,0,.11,0,.17s0,.07,0,.11h0a1.11,1.11,0,0,0,0,.19.45.45,0,0,1,0,.11s0,.09,0,.13l.05.15a.43.43,0,0,1,0,.07,1.62,1.62,0,0,0,.1.18.7.7,0,0,0,.08.1l.1.12.09.07.14.12.07,0,.19.1h0l.12,0,.15,0a1.43,1.43,0,0,0,.29,0h26a1.43,1.43,0,0,0,.29,0l.15,0,.12,0h0l.19-.1.07,0,.14-.12.09-.07.11-.13.07-.09a1.14,1.14,0,0,0,.1-.19l0-.06c0-.05,0-.1,0-.15s0-.08,0-.13a.45.45,0,0,1,0-.11,1.11,1.11,0,0,0,0-.19h0s0-.07,0-.11,0-.12,0-.17a1.21,1.21,0,0,0,0-.18l0-.1v0h0l-2-5h0a1.62,1.62,0,0,0-.1-.18.59.59,0,0,0,0-.08,1.47,1.47,0,0,0-.1-.13l-.09-.1-.09-.08-.13-.1-.14-.08-.11-.06-.12,0-.16,0h-.09l-.21,0h0c-3.6,0-6.5-3.81-6.5-7V41.45A19.48,19.48,0,0,0,50,23a1.24,1.24,0,0,0,0-.27V18.88C56.3,17.94,61,11.29,61,5.5ZM3.13,7H11v8.83C7,15,3.81,10.91,3.13,7ZM40.46,55.93,41.28,58H19.72l.82-2.07C25.38,55.29,29,50.34,29,46V41.92c.5,0,1,.08,1.5.08s1,0,1.5-.08V46C32,50.34,35.62,55.29,40.46,55.93ZM30.5,39A16.52,16.52,0,0,1,14,22.5V3H47V22.5A16.52,16.52,0,0,1,30.5,39ZM50,15.83V7h7.87C57.19,10.91,54,15,50,15.83Z"/><path d="M38.73,14.13,34,13.41,31.86,8.87a1.5,1.5,0,0,0-2.72,0L27,13.41l-4.74.72a1.5,1.5,0,0,0-1.19,1,1.48,1.48,0,0,0,.35,1.52l3.47,3.56-.82,5a1.48,1.48,0,0,0,.61,1.47,1.5,1.5,0,0,0,1.59.08l4.22-2.33,4.21,2.33a1.5,1.5,0,0,0,1.59-.08,1.51,1.51,0,0,0,.62-1.47l-.82-5,3.47-3.56a1.48,1.48,0,0,0,.35-1.52A1.5,1.5,0,0,0,38.73,14.13Zm-5.3,4.53A1.47,1.47,0,0,0,33,20l.44,2.74-2.23-1.24a1.51,1.51,0,0,0-1.46,0l-2.24,1.24L28,20a1.47,1.47,0,0,0-.41-1.29l-2-2,2.64-.4a1.49,1.49,0,0,0,1.13-.84L30.5,13l1.11,2.37a1.5,1.5,0,0,0,1.13.85l2.65.4Z"/>
        </svg>
    );
}

export function VideoIcon() {
    return (
        <svg viewBox="0 0 24 24" className="cpd-icon">
            <path d="M22.5,10.5l-4.5,3c0-0.9-0.4-1.7-1.1-2.3c1.5-0.9,2.6-2.6,2.6-4.5c0-2.9-2.4-5.2-5.2-5.2S9,3.9,9,6.8 c0,1.5,0.6,2.8,1.6,3.8H7.8C8.6,9.7,9,8.7,9,7.5C9,5,7,3,4.5,3S0,5,0,7.5c0,1.4,0.6,2.6,1.6,3.4C0.6,11.4,0,12.4,0,13.5v6 c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3v-0.8l4.5,3.8c0.8,0,1.5-0.7,1.5-1.5v-9C24,11.2,23.3,10.5,22.5,10.5z M1.5,7.5 c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S1.5,9.2,1.5,7.5z M16.5,19.5c0,0.8-0.7,1.5-1.5,1.5H3c-0.8,0-1.5-0.7-1.5-1.5v-6 C1.5,12.7,2.2,12,3,12h12c0.8,0,1.5,0.7,1.5,1.5V19.5z M14.2,10.5c-2.1,0-3.8-1.7-3.8-3.8S12.2,3,14.2,3S18,4.7,18,6.8 S16.3,10.5,14.2,10.5z M22.5,21L18,17.2c0-0.5,0-1.8,0-2.2l4.5-3C22.5,13.1,22.5,20.4,22.5,21z"/>
        </svg>
    );
}

export function WatchIcon() {
    return (
        <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 39 61">
            <path d="M39,30.5A19.45,19.45,0,0,0,32.54,16L31.08,1.35A1.5,1.5,0,0,0,29.59,0H9.41A1.5,1.5,0,0,0,7.92,1.36L6.51,16a19.4,19.4,0,0,0,0,29L7.92,59.64A1.5,1.5,0,0,0,9.41,61H29.59a1.5,1.5,0,0,0,1.49-1.36L32.49,45A19.41,19.41,0,0,0,39,30.5ZM10.78,3H28.23l1.06,10.66a19.34,19.34,0,0,0-19.54,0ZM3,30.5A16.5,16.5,0,1,1,19.5,47,16.52,16.52,0,0,1,3,30.5ZM28.22,58H10.78l-1-10.64a19.32,19.32,0,0,0,19.5,0Z"/><path d="M19.5,32h10a1.5,1.5,0,0,0,0-3H21V20.5a1.5,1.5,0,0,0-3,0v10A1.5,1.5,0,0,0,19.5,32Z"/>
        </svg>
    );
}
